<template>
  <div class="campaign-type-modal rounded overflow-hidden text-dark bg-white p-3.5">
    <div class="campaign-type-modal__header flex items-center justify-between gap-3 mb-3.5">
      <div class="flex items-center gap-1">
        <svg width="16" height="16" fill="none">
          <use :xlink:href="`#campaign-type`"></use>
        </svg>
        <h2 class="campaign-type-modal__title font-bold mb-0">Choose Campaign Type</h2>
      </div>
      <button class="campaign-type-modal__close text-base" @click="close"><i class="icon-Close font-bold"></i></button>
    </div>
    <!-- body -->
    <div class="campaign-type-modal__body mb-3.5">
      <el-radio v-model="type" class="radio-item-label mb-1 mr-0" :class="{ active: type === 'simple' }" label="simple">
        <span class="font-bold text-dark text-15px">Simple</span>
        <div class="mt-1 text-muted leading-normal">Straightforward campaigns with a single budget and period.</div>
      </el-radio>

      <el-radio v-model="type" class="radio-item-label" :class="{ active: type === 'complex' }" label="complex">
        <span class="font-bold text-dark text-15px">Multiple flights</span>
        <div class="mt-1 text-muted leading-normal">
          Campaigns with multiple flights, each with a different budget and <br />
          period.
        </div>
      </el-radio>
    </div>
    <!-- end body -->
    <div class="campaign-type-modal__footer-action flex justify-end items-center gap-2">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" :disabled="type === null" @click="ctaContinue" type="primary">Continue</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CampaignType',
  props: {
    meta: {
      type: null,
      required: '',
    },
  },
  data() {
    return {
      type: null,
    }
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    ctaContinue() {
      this.close()
      this.$router.push({ name: 'social-boost-create', params: { type: this.type } })
    },
  },
}
</script>
<style lang="scss">
.campaign-type-modal {
  .radio-item-label {
    @apply w-full p-3 rounded border border-[#e4e7ed];

    &.active {
      @apply border-primary;
    }
  }

  // Overwrite el-radio style
  .radio-item-label:hover .el-radio__inner,
  .el-radio__input.is-checked .el-radio__inner {
    @apply border-primary bg-transparent;
  }
  .el-radio__input.is-checked .el-radio__inner {
    &:after {
      @apply w-[7px] h-[7px] bg-primary;
    }
  }
}
</style>
